import React, { PureComponent } from "react";

class Home extends PureComponent {
  render() {
    return <div> Home :</div>;
  }
}
export default Home;
